var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.169,
    height: 15.707,
    viewBox: "0 0 17.169 15.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14680",
    "data-name": "Path 14680",
    d: "M2.25,9.88,9.16,2.97a.869.869,0,0,1,1.228,0L17.3,9.88M3.986,8.144v7.813a.868.868,0,0,0,.868.868H8.038V13.063a.868.868,0,0,1,.868-.868h1.736a.868.868,0,0,1,.868.868v3.762h3.183a.868.868,0,0,0,.868-.868V8.144M6.88,16.825h6.366",
    transform: "translate(-1.189 -1.868)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.67c3811b96c773e9ce1eb466cc791f78.svg";
export { ForwardRef as ReactComponent };